/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { CreateUserRequest } from '../entities/CreateUserRequest'
import type { ToZod } from '@kubb/plugin-zod/utils'
import { v1UserRoleStringSchema } from './v1/userRoleStringSchema'
import { z } from 'zod'

export const createUserRequestSchema = z.object({
  email: z.string(),
  name: z.string().min(3).max(255),
  phone: z.number().int(),
  role: z.lazy(() => v1UserRoleStringSchema),
}) as unknown as ToZod<CreateUserRequest>